interface RegistrationVerificationCardProps {
  registrationPrefix: string;
  businessName: string;
  taxIdentificationNumber?: string;
}

const DetailRow = ({ label, value }: { label: string; value: string }) => (
  <div className="flex items-center justify-between rounded-lg border border-neutral-100 bg-white px-4 py-4">
    <span className="text-sm text-neutral-600">{label}</span>
    <span className="text-right text-sm font-medium text-neutral-900">
      {value}
    </span>
  </div>
);

const RegistrationVerificationCard = ({
  registrationPrefix,
  businessName,
  taxIdentificationNumber,
}: RegistrationVerificationCardProps) => (
  <div className="rounded-xl bg-neutral-25 p-6">
    <div className="mb-4 flex items-start justify-between gap-4">
      <div>
        <p className="text-sm font-medium text-neutral-900">
          {registrationPrefix} Verification
        </p>
        <p className="text-sm text-neutral-600">
          We&apos;ve successfully matched your {registrationPrefix} details with
          the CAC database.
        </p>
      </div>
      <span className="rounded-full bg-accent-success px-3 py-1 text-xs font-medium text-white">
        VERIFIED
      </span>
    </div>

    <div className="flex flex-col gap-y-3">
      <DetailRow label="Business Name" value={businessName} />
      {taxIdentificationNumber && (
        <DetailRow
          label="TIN (Tax Identification Number)"
          value={taxIdentificationNumber}
        />
      )}
    </div>
  </div>
);

export default RegistrationVerificationCard;
